import { FormEvent, useState } from 'react';
import { Alert, Box, Button, Paper, Stack, TextField, Typography } from '@mui/material';
import AuthController from '../../Api/authController';

const ForgotPasswordPage = () => {
    const [identifier, setIdentifier] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const submit = async (event: FormEvent) => {
        event.preventDefault(); setLoading(true);
        try { const res = await AuthController.forgotPassword(identifier); setMessage(res.data.message); }
        catch { setMessage('Jesli konto istnieje, wyslalismy instrukcje zmiany hasla'); }
        finally { setLoading(false); }
    };
    return <Box minHeight="100vh" display="grid" sx={{ placeItems: 'center', bgcolor: '#f4f6fb', p: 2 }}>
        <Paper component="form" onSubmit={submit} sx={{ p: 4, width: '100%', maxWidth: 440 }}>
            <Stack spacing={2}><Typography variant="h5" fontWeight={700}>Odzyskiwanie hasla</Typography>
                <Typography color="text.secondary">Podaj login lub adres e-mail przypisany do konta.</Typography>
                {message && <Alert severity="info">{message}</Alert>}
                <TextField label="Login lub e-mail" value={identifier} onChange={(e) => setIdentifier(e.target.value)} required autoFocus />
                <Button type="submit" variant="contained" disabled={loading}>{loading ? 'Wysylanie...' : 'Wyslij link'}</Button>
                <Button href="/logowanie">Wroc do logowania</Button>
            </Stack>
        </Paper>
    </Box>;
};
export default ForgotPasswordPage;
